import dayjs from "dayjs";
import { downloadBase64File } from "../../../../../common/utils/download_utils";
import { ReportMimeType } from "../../../../../common/utils/report_callback";
import { IGetReportComprasRelatorioComprasUseCase } from "../../../presentation/useCases/read/get_report_compras_relatorio_compras_use_case";
import { ReportData } from "../../models/report_data";
import { IReportsRepository } from "../../repositories/reports_repository";

/**
 * GetReportComprasRelatorioComprasUseCase
 */

export class GetReportComprasRelatorioComprasUseCase implements IGetReportComprasRelatorioComprasUseCase {
  constructor(private readonly repository: IReportsRepository) { }

  async getReportComprasRelatorioCompras(
    requiredMimeType: ReportMimeType | null,
    centroCustos: number[] | null,
    titulo: string | null,
    ordemCompras: number[] | null,
    subcontas: number[] | null,
    fornecedores: number[] | null,
    dataOC: (Date | null)[] | null,
    produtoServicos: number[] | null,
    dataPago: (Date | null)[] | null,
    statusOC: number[] | null,
    idUsuario: number | null,
  ): Promise<ReportData> {
    const response = await this.repository.getReportComprasRelatorioCompras(
      requiredMimeType,
      centroCustos,
      titulo,
      ordemCompras,
      subcontas,
      fornecedores,
      dataOC,
      produtoServicos,
      dataPago,
      statusOC,
      idUsuario
    );

    if (response.mimeType !== "text/html") {
      const arquivoData = response.bytes;
      const arquivoNome = `relatorio_compras_${dayjs().format('YYYYMMDD_HHmmss')}.${response.filenameExtension}`;

      await downloadBase64File(arquivoNome, arquivoData);
    }

    return response;
  }
}
